module.exports = __webpack_public_path__ + "img/w1_1.0ae57444.png";